import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetMyOrdersMutation } from "../slices/OrdersSlice";
import { Col, Row, Table } from "react-bootstrap";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { Link, useNavigate } from "react-router-dom";

const OrdersHistoryScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);

  // const {
  //   data: myOrders,
  //   isLoading,
  //   refetch,
  //   error,
  // } = useGetMyOrdersMutation({ token: userInfo?.token });

  const [myOrders, setMyOrders] = useState([]);
  const [getMyOrders, { isLoading, error }] = useGetMyOrdersMutation();
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await getMyOrders({
          token: userInfo?.token,
          visitorId: userInfo?.visitorId,
        }).unwrap();
        setMyOrders(response);
      } catch (err) {
        console.error("Order fetch error:", err);
      }
    };

    if (userInfo?.token || userInfo?.visitorId) {
      fetchOrders();
    }
  }, [userInfo, getMyOrders]);

  // const navigate = useNavigate();
  // useEffect(() => {
  //   if (error) navigate("/login", { state: { redirectTo: "/orderHistory" } });
  // }, [error, navigate]);

  return (
    <>
      <h5 style={{ color: "black" }}>Orders History</h5>
      <Row>
        <Col md={9}>
          {isLoading ? (
            <Loader />
          ) : error ? (
            <Message>{error?.data?.error}</Message>
          ) : (
            <div style={{ height: "100vh" }} className="tableContainer">
              <Table
                striped
                bordered
                hover
                responsive="sm"
                className="table-custom"
              >
                <thead
                  style={{
                    backgroundColor: "rgb(17, 93, 102)",
                    border: "0.5px solid rgb(1, 65, 55)",
                  }}
                >
                  <tr>
                    <th>#</th>
                    <th>Item Name</th>
                    <th>Count</th>
                    <th>Date</th>
                    <th>GST</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {myOrders?.map((order, orderIndex) => (
                    <tr key={order._id}>
                      <td style={{ color: "rgb(17, 93, 102)" }}>
                        <Link to={`/myOrders/${order._id}`}>
                          {orderIndex + 1}
                        </Link>
                      </td>
                      <td style={{ color: "rgb(17, 93, 102)" }}>
                        {order.orderDetails.map((item, i) => (
                          <div key={i}>
                            {item.itemName} - {item.itemQuantity}
                          </div>
                        ))}
                      </td>
                      <td style={{ color: "rgb(17, 93, 102)" }}>
                        {order.orderDetails.reduce(
                          (total, item) => total + item.itemQuantity,
                          0
                        )}
                      </td>
                      <td style={{ color: "rgb(17, 93, 102)" }}>
                        {order.createdAt.split("T")[0]}
                      </td>
                      <td style={{ color: "rgb(17, 93, 102)" }}>
                        <span>{order.totalTax}</span>
                      </td>
                      <td style={{ color: "rgb(17, 93, 102)" }}>
                        ₹{order.grossTotal.toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};

export default OrdersHistoryScreen;
